import {SetState} from '@wandb/weave/common/util/types';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Menu} from 'semantic-ui-react';

import {DEFAULT_PAGE_SIZE_OPTIONS} from './util';
import type {WBReactTableProps} from './WBReactTable';
import {WBReactTablePagination} from './WBReactTablePagination';

type WBReactTableFooterProps = Pick<
  WBReactTableProps,
  'pageSizeOptions' | 'hasNextPage' | 'fetchingNextPage' | 'onFetchNextPage'
> & {
  page: number;
  pageSize: number;
  rowCount: number;
  changePageSize: (newPageSize: number) => void;
  setPage: SetState<number>;
};

export const WBReactTableFooter: React.FC<WBReactTableFooterProps> = React.memo(
  ({
    page,
    pageSize,
    pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
    rowCount,
    changePageSize,
    hasNextPage = false,
    fetchingNextPage = false,
    onFetchNextPage,
    setPage,
  }) => {
    return (
      <Tailwind>
        <Menu
          secondary
          style={{
            margin: '0px',
            height: '40px',
            minHeight: '40px',
            overflow: 'hidden',
            alignItems: 'center',
            justifyContent: 'flex-end',
            borderTop: '0.5px solid #e5e7eb',
          }}>
          <WBReactTablePagination
            page={page}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            rowCount={rowCount}
            changePageSize={changePageSize}
            hasNextPage={hasNextPage}
            fetchingNextPage={fetchingNextPage}
            onFetchNextPage={onFetchNextPage}
            setPage={setPage}
          />
        </Menu>
      </Tailwind>
    );
  }
);
